import { ActionList, Icon, Popover } from '@shopify/polaris';
import { CheckIcon } from '@shopify/polaris-icons';
import { useState } from 'react';
import CustomBadge from '../CustomBadge';
import TooltipWithAction from '../TooltipWithAction';

export enum FontFamily {
  Arial = 'inherit',
  FiraSans = 'Fira Sans',
  Poppins = 'Poppins',
  Inter = 'Inter',
}

const FONT_FAMILIES = [
  { label: 'Arial', value: FontFamily.Arial, cdn: '' },
  {
    label: 'Fira Sans',
    value: FontFamily.FiraSans,
    cdn: 'https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;500;600;700&display=swap',
  },
  {
    label: 'Poppins',
    value: FontFamily.Poppins,
    cdn: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap',
  },
  {
    label: 'Inter',
    value: FontFamily.Inter,
    cdn: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
  },
];

const FontFamilyButton = ({
  selectedFont,
  setSelectedFont,
  disabled,
}: {
  selectedFont: FontFamily;
  setSelectedFont: (font: FontFamily) => void;
  disabled?: boolean;
}) => {
  const [active, setActive] = useState(false);

  const handleFontSelect = (fontValue: FontFamily) => {
    document.execCommand('fontName', false, fontValue);
    setSelectedFont(fontValue);
    setActive(false);
  };

  const componentForActivator = () => {
    return disabled ? (
      <TooltipWithAction content={<CustomBadge marginLeft={false} />} activatorWrapper="div">
        <button className="rsw-btn" style={{ cursor: 'not-allowed', opacity: '0.5' }}>
          𝐀
        </button>
      </TooltipWithAction>
    ) : (
      <button className="rsw-btn" onClick={() => setActive(!active)}>
        𝐀
      </button>
    );
  };

  return (
    <Popover active={active} activator={componentForActivator()} onClose={() => setActive(false)}>
      <ActionList
        items={FONT_FAMILIES.map((font) => ({
          content: font.label,
          onAction: () => handleFontSelect(font.value),
          suffix: font.value === selectedFont ? <Icon source={CheckIcon} /> : null,
        }))}
      />
    </Popover>
  );
};

export default FontFamilyButton;
